module.exports = __webpack_public_path__ + "img/testament.22b525ee.png";